import { Injectable } from "@angular/core";
import { FileUploadsStore } from "./file-uploads.store";
import { selectMany } from "@ngneat/elf-entities";

@Injectable({ providedIn: "root" })
export class FileUploadsQuery {
	constructor(private fileUploadsStore: FileUploadsStore) {}

	selectMany = (ids: string[]) => {
		return this.fileUploadsStore.store.pipe(selectMany(ids));
	};
}
